import { TProductParams } from '../type'

type TParametersRequest =
  | {
      id: number
      parameterValue: {
        value: string | number | boolean | null
      }
    }[]
  | []

export const getArrayOfAppealParameters = (
  parameters: TProductParams[] | null,
): TParametersRequest => {
  return parameters?.length
    ? parameters.map(parameter => ({
        id: parameter.id,
        parameterValue: {
          value: parameter.parameterValue?.value,
        },
      }))
    : []
}
